import { PlusIcon, TrashIcon } from "@phosphor-icons/react";
import { INPUT_CLS } from "../crm/Form";

export default function TestReadingsTable({ value, onChange, disabled }) {
  const rows = value || [];

  const update = (idx, patch) => {
    const next = rows.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };
  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const add = () => onChange([...rows, { label: "", value: "", unit: "" }]);

  return (
    <div data-testid="readings-table" className="space-y-2">
      <div className="grid grid-cols-12 gap-2 text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
        <div className="col-span-5">Reading</div>
        <div className="col-span-3">Value</div>
        <div className="col-span-3">Unit</div>
        <div className="col-span-1" />
      </div>
      {rows.length === 0 && (
        <div className="text-xs text-slate-500">
          No readings recorded yet.
        </div>
      )}
      {rows.map((row, i) => (
        <div
          key={i}
          className="grid grid-cols-12 gap-2 items-start"
          data-testid={`readings-row-${i}`}
        >
          <input
            type="text"
            value={row.label || ""}
            disabled={disabled}
            onChange={(e) => update(i, { label: e.target.value })}
            placeholder="e.g. AC voltage L1-L2"
            className={`${INPUT_CLS} col-span-5`}
            data-testid={`readings-label-${i}`}
          />
          <input
            type="text"
            value={row.value || ""}
            disabled={disabled}
            onChange={(e) => update(i, { value: e.target.value })}
            placeholder="240"
            className={`${INPUT_CLS} col-span-3 font-data`}
            data-testid={`readings-value-${i}`}
          />
          <input
            type="text"
            value={row.unit || ""}
            disabled={disabled}
            onChange={(e) => update(i, { unit: e.target.value })}
            placeholder="V / A / kW"
            className={`${INPUT_CLS} col-span-3`}
            data-testid={`readings-unit-${i}`}
          />
          <button
            type="button"
            disabled={disabled}
            onClick={() => remove(i)}
            data-testid={`readings-remove-${i}`}
            aria-label="Remove reading"
            className="col-span-1 inline-flex h-9 items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:text-red-600 hover:border-red-200 disabled:opacity-40"
          >
            <TrashIcon size={14} />
          </button>
        </div>
      ))}
      <button
        type="button"
        disabled={disabled}
        onClick={add}
        data-testid="readings-add"
        className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-slate-700 hover:text-amber-700 disabled:opacity-40"
      >
        <PlusIcon size={12} weight="bold" /> Add reading
      </button>
    </div>
  );
}
